export const environment = {
  production: false,
  apiUrl :'https://dev.hmwssb.infosharesystems.io/api/api/v1',
  //apiUrl :'http://hmwssb-alb-1965751162.ap-south-1.elb.amazonaws.com/api/api/v1', //prod
  //apiUrl : 'http://65.0.48.143:8081/api/api/v1', //postgre
  //apiUrl : 'http://13.201.166.45/api/api/v1',
  //apiUrl :'http://localhost:8092/api/v1',
  //apiUrl :'/api/api/v1',
   //apiUrl :'http://65.0.48.143/api/api/v1',
  // apiUrl :'http://localhost:8092/api/v1',
  // apiUrl: 'http://65.0.45.165/api/api/v1',
    //apiUrl:'http://65.0.107.29/api/api/v1', //postgre Latest UAT
    tankerDashboardURL:'https://dev.hmwssb.infosharesystems.io:8080/',
    fsDashboardURL:'https://dev.hmwssb.infosharesystems.io:8081',
    // apiUrl :'https://dat.hyderabadwater.gov.in/api/api/v1', //latest prod

 
    
  encryptionKey: 'key',
  googleMapsApiKey: 'AIzaSyD2slG3kcd82ulbkNt87SEETzrWeGEAnlA'
};